<basket-free-delivery-notice [backgroundColor]="content?.backgroundColor"
                             [textColor]="content?.textColor"
                             [isBasketView]="isBasketView" />